import React from 'react';
import '../css/Image.scss';

export default function Image({ src, borderColor, alt }) {
    return (
        <img src={src} className="ImageImg" alt={alt} style={{ borderColor }} />
    );
}
